import type { CustomDisclaimerServiceErrorCode } from '../types/customDisclaimers';

export class CustomDisclaimerServiceError extends Error {
  constructor(
    public readonly code: CustomDisclaimerServiceErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'CustomDisclaimerServiceError';
  }
}